// extracted by mini-css-extract-plugin
export default {"holder":"crwghjebh","container":"cdgvmgdap","text":"cowtk9827","icon":"cd2gzr6ml"};